export default "__VITE_ASSET__CpptVqh2__"